// crm namespace — Broadcast composer (admin/crm/email/BroadcastComposer.jsx,
// BroadcastConfirmDialog.jsx): audience picker, subject/body, preview, send confirmation.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "broadcast.title": "Envoyer un e-mail groupé",
    "broadcast.audienceLabel": "Destinataires",
    "broadcast.audienceCurrentFilter": "Filtre actuel",
    "broadcast.subjectLabel": "Objet",
    "broadcast.bodyLabel": "Message",
    "broadcast.preview": "Aperçu",
    "broadcast.previewTitle": "Aperçu — {name}",
    "broadcast.send": "Envoyer",
    "broadcast.confirmTitle": "Envoyer l'e-mail groupé ?",
    "broadcast.confirmAudience": "Destinataires : vue enregistrée « {name} »",
    "broadcast.confirmAudienceFilter": "Destinataires : filtre actuel",
    "broadcast.confirmCount": "Ceci sera envoyé à {n} clients",
    "broadcast.previewStats": "{sendable} sur {matched} clients recevront cet e-mail",
    "broadcast.previewNoAudience": "Choisissez une audience pour voir qui recevra cet e-mail et pouvoir l'envoyer.",
    "broadcast.confirmSkipped": "{n} désabonnés depuis l'enregistrement de la vue sont ignorés automatiquement",
    "broadcast.sent": "E-mail groupé envoyé à {n} clients",
    "broadcast.errAudience": "Choisissez une vue enregistrée ou le filtre actuel.",
    "broadcast.errSubject": "Ajoutez un objet.",
    "broadcast.errBody": "Ajoutez un message.",
  },
  en: {
    "broadcast.title": "Send broadcast",
    "broadcast.audienceLabel": "Audience",
    "broadcast.audienceCurrentFilter": "Current filter",
    "broadcast.subjectLabel": "Subject",
    "broadcast.bodyLabel": "Body",
    "broadcast.preview": "Preview",
    "broadcast.previewTitle": "Preview — {name}",
    "broadcast.send": "Send",
    "broadcast.confirmTitle": "Send broadcast?",
    "broadcast.confirmAudience": "Audience: saved view “{name}”",
    "broadcast.confirmAudienceFilter": "Audience: current filter",
    "broadcast.confirmCount": "This will go to {n} clients",
    "broadcast.previewStats": "{sendable} of {matched} clients will receive this",
    "broadcast.previewNoAudience": "Choose an audience to see who will receive this email and to send it.",
    "broadcast.confirmSkipped": "{n} unsubscribed since the view was saved are skipped automatically",
    "broadcast.sent": "Broadcast sent to {n} clients",
    "broadcast.errAudience": "Pick a saved view or the current filter.",
    "broadcast.errSubject": "Add a subject.",
    "broadcast.errBody": "Add a message.",
  },
  es: {
    "broadcast.title": "Enviar correo masivo",
    "broadcast.audienceLabel": "Destinatarios",
    "broadcast.audienceCurrentFilter": "Filtro actual",
    "broadcast.subjectLabel": "Asunto",
    "broadcast.bodyLabel": "Mensaje",
    "broadcast.preview": "Vista previa",
    "broadcast.previewTitle": "Vista previa — {name}",
    "broadcast.send": "Enviar",
    "broadcast.confirmTitle": "¿Enviar el correo masivo?",
    "broadcast.confirmAudience": "Destinatarios: vista guardada «{name}»",
    "broadcast.confirmAudienceFilter": "Destinatarios: filtro actual",
    "broadcast.confirmCount": "Esto se enviará a {n} clientes",
    "broadcast.previewStats": "{sendable} de {matched} clientes recibirán esto",
    "broadcast.previewNoAudience": "Elige una audiencia para ver quién recibirá este correo y poder enviarlo.",
    "broadcast.confirmSkipped": "{n} personas que se dieron de baja desde que se guardó la vista se omiten automáticamente",
    "broadcast.sent": "Correo masivo enviado a {n} clientes",
    "broadcast.errAudience": "Elige una vista guardada o el filtro actual.",
    "broadcast.errSubject": "Añade un asunto.",
    "broadcast.errBody": "Añade un mensaje.",
  },
};
